import clsx from "clsx";
import {
  PremiumPropertyCardSkeleton,
  PropertyCardSkeleton,
} from "../../Card/Loading";

export const PropertyListLoading = () => {
  return (
    <ul className={clsx("flex flex-col gap-4 w-full overflow-hidden px-1")}>
      <PropertyCardSkeleton />
      <PremiumPropertyCardSkeleton />
      <PropertyCardSkeleton />
      <PremiumPropertyCardSkeleton />
      <PropertyCardSkeleton />
      <PremiumPropertyCardSkeleton />
      <PropertyCardSkeleton />
      <PremiumPropertyCardSkeleton />
    </ul>
  );
};
